import { TireInformationButton } from '@components/Booking/TireInformationButton';
import { ApiErrorMessageWithTrans } from '@components/Error/ApiErrorMessageWithTrans';
import { ContentWrapperCustomerApp } from '@components/Layouts/ContentWrapperCustomerApp';
import { NoddiLoadingScreenWithTrans } from '@components/Loading/NoddiLoadingScreenWithTrans';
import { TireSeason } from '@navio/nsdk';
import { noddiAsync, URLKeys } from 'noddi-async';
import { getCarDisplayName } from 'noddi-util';
import { LatestTireMeasurements, useAuthContext } from 'noddi-web';
import { useParams } from 'react-router-dom';
import { getCommonTranslations } from '../../../../utils/commonTranslations';

export const WheelMeasurementPage = () => {
  const { currentUserGroupId: userGroupId } = useAuthContext();
  const { carId } = useParams();

  const {
    data: car,
    isPending,
    error: carError
  } = noddiAsync.useGet({
    type: URLKeys.getUserGroupCar,
    input: { userGroupId: userGroupId!, carId: parseInt(carId!) }
  });

  if (isPending) {
    return <NoddiLoadingScreenWithTrans />;
  }

  if (carError) {
    return <ApiErrorMessageWithTrans error={carError} />;
  }

  const title = getCarDisplayName({ car, showYear: false });

  return (
    <ContentWrapperCustomerApp title={title}>
      <div className='flex flex-col gap-5'>
        <TireInformationButton />
        <LatestTireMeasurements
          carId={car.id}
          tireSeason={TireSeason.WINTER}
          translations={getCommonTranslations().wheelMeasurements}
        />
        <LatestTireMeasurements
          carId={car.id}
          tireSeason={TireSeason.SUMMER}
          translations={getCommonTranslations().wheelMeasurements}
        />
      </div>
    </ContentWrapperCustomerApp>
  );
};
